export default function ValuesSection() {
  const values = [
    {
      icon: 'ri-heart-line',
      title: '尊厳を守る',
      description: 'ご利用者様の尊厳を何よりも大切にし、その方らしい生活を支えます。年齢や状態に関わらず、一人の人間として敬意を持って接します。'
    },
    {
      icon: 'ri-user-heart-line',
      title: '個別性を重視',
      description: '画一的なサービスではなく、お一人おひとりの生活習慣、価値観、ご希望に合わせたオーダーメイドのケアを提供します。'
    },
    {
      icon: 'ri-team-line',
      title: 'チームで支える',
      description: 'ヘルパー、ケアマネージャー、ご家族が連携し、チーム全体でご利用者様の生活を支えます。情報共有と協力を大切にしています。'
    },
    {
      icon: 'ri-seedling-line',
      title: '成長し続ける',
      description: 'スタッフ一人ひとりが学び続け、成長することで、より質の高いケアを提供できると考えています。研修や資格取得を積極的に支援します。'
    }
  ];

  return (
    <section className="py-24 bg-gray-50 observe-animation opacity-0">
      <div className="container mx-auto px-6 lg:px-12">
        <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-16 text-center">
          大切にしている考え方
        </h2>

        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-10 shadow-sm hover:shadow-lg transition-all duration-300"
            >
              <div className="w-16 h-16 bg-cyan-500 rounded-full flex items-center justify-center mb-6">
                <i className={`${value.icon} text-3xl text-white`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {value.title}
              </h3>
              
              <p className="text-gray-700 leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
